import Price from '~/utils/Price/Price';
import { ProductPrice } from '~/Product';

import ProductHistoryPriceChange from './ProductHistoryPriceChange';

export interface RawProductHistoryPriceChange {
	previous: { priceType: string; value: string; currency: string } | null;
	current: { priceType: string; value: string; currency: string } | null;
}

export default function mapProductHistoryPriceChange(change: RawProductHistoryPriceChange): ProductHistoryPriceChange {
	return new ProductHistoryPriceChange(
		change.previous !== null
			? new ProductPrice(change.previous.priceType, new Price(change.previous.value, change.previous.currency), 0)
			: null,
		change.current !== null
			? new ProductPrice(change.current.priceType, new Price(change.current.value, change.current.currency), 0)
			: null
	);
}
